import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';

// LocalForage setup
import localforage from 'localforage';
localforage.config({
  name: 'Normal Chat'
});

// App pages
import App from './App';

ReactDOM.render(
  <App />,
  document.getElementById('root')
);



// WEBPACK FOOTER //
// ./src/index.js